import { Stepper, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

export type AgecComplianceStepTooltipLabelProps = {
  /** Persisted AGEC step for an eligible product: `0`, `1`, or `2`. */
  readonly step: number
}

/**
 * Vertical Mantine stepper for the AGEC compliance tooltip (applicable products only).
 * `active` matches persisted step: 0 = neither step complete, 1 = first complete, 2 = both complete.
 */
export const AgecComplianceStepTooltipLabel = ({
  step,
}: AgecComplianceStepTooltipLabelProps) => {
  const { t } = useTranslation("products")

  const step1Reached = step >= 1
  const step2Reached = step >= 2

  const step1Description = step1Reached
    ? t("lists.cells.agec.tooltips.step1Reached")
    : t("lists.cells.agec.tooltips.step1Unreached")

  const step2Description = step2Reached
    ? t("lists.cells.agec.tooltips.step2Reached")
    : t("lists.cells.agec.tooltips.step2Unreached")

  return (
    <Stepper
      orientation="vertical"
      active={step}
      allowNextStepsSelect={false}
      color="primary"
      iconSize={20}
      size="xs"
      styles={{
        step: {
          minHeight: "unset",
        },
        stepBody: {
          marginTop: 0,
        },
        verticalSeparator: {
          borderColor: "var(--mantine-color-gray-3)",
        },
      }}
    >
      <Stepper.Step
        label={
          <Text size="xs" c="dimmed" fw={500} component="span">
            {t("lists.cells.agec.step1")}
          </Text>
        }
        description={<Text size="sm">{step1Description}</Text>}
      />
      <Stepper.Step
        label={
          <Text size="xs" c="dimmed" fw={500} component="span">
            {t("lists.cells.agec.step2")}
          </Text>
        }
        description={<Text size="sm">{step2Description}</Text>}
      />
    </Stepper>
  )
}
